import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

// ngrx
import { Store } from '@ngrx/store';
import { AppState } from '@app/store/state';
import { ParseService } from './parse/parse.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard {
    constructor(private store: Store<AppState>, private parse: ParseService) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // const user = this.parse.getCurrentUser()
        // if (!user) {
        //     this.store.dispatch(fromAuth.LogOut());
        // } else {
        //     return true;
        // }
        return true;
    }
}
